module.exports = __webpack_public_path__ + "files/2098a84eee08d6b7c6482e61660b2068.png";